import React, { useEffect, useState } from 'react'
import { supabase } from '../supabaseClient'

function fmtDate(d) {
  if (!d) return '—'
  return new Date(d + 'T00:00:00').toLocaleDateString('en-IN', { day:'2-digit', month:'short', year:'numeric' })
}
function fmtTime(t) {
  if (!t) return ''
  return new Date('2000-01-01T' + t).toLocaleTimeString('en-IN', { hour:'2-digit', minute:'2-digit', hour12:true })
}
function initials(name) {
  return (name || '?').split(' ').filter(Boolean).map(w => w[0]).join('').slice(0, 2).toUpperCase()
}

const TABS = [
  { id: 'classes',  label: 'Classes',  icon: '📅' },
  { id: 'students', label: 'Students', icon: '🎓' },
  { id: 'teachers', label: 'Teachers', icon: '🧑‍🏫' },
]

const inp = { background:'rgba(var(--fg-rgb),0.05)', border:'0.5px solid rgba(var(--fg-rgb),0.1)', borderRadius:'8px', padding:'8px 12px', fontSize:'13px', color:'rgba(var(--fg-rgb),var(--a85))', outline:'none', fontFamily:'inherit' }

function EmailChip({ email }) {
  const [copied, setCopied] = useState(false)
  if (!email) return <span style={{ fontSize:'11px', color:'rgba(var(--fg-rgb),var(--a20))' }}>No email</span>
  return (
    <span style={{ display:'inline-flex', alignItems:'center', gap:'6px' }}>
      <a href={`mailto:${email}`} style={{ fontSize:'11px', color:'#5aabff', textDecoration:'none' }}>{email}</a>
      <button
        onClick={() => { navigator.clipboard.writeText(email); setCopied(true); setTimeout(() => setCopied(false), 1500) }}
        title="Copy email"
        style={{ fontSize:'9px', padding:'1px 6px', borderRadius:'5px', background:'rgba(var(--fg-rgb),0.07)', color:'rgba(var(--fg-rgb),var(--a40))', border:'none', cursor:'pointer' }}>
        {copied ? '✓' : 'copy'}
      </button>
    </span>
  )
}

export default function Directory() {
  const [tab,        setTab]        = useState('classes')
  const [profiles,   setProfiles]   = useState([])
  const [classes,    setClasses]    = useState([])
  const [enrollments,setEnrollments]= useState([])
  const [courses,    setCourses]    = useState([])
  const [loading,    setLoading]    = useState(true)
  const [search,     setSearch]     = useState('')
  const [expanded,   setExpanded]   = useState(null)

  useEffect(() => { load() }, [])

  async function load() {
    setLoading(true)
    const [{ data: p }, { data: c }, { data: e }, { data: co }] = await Promise.all([
      supabase.from('profiles').select('*').order('full_name'),
      supabase.from('classes').select('*').order('class_date', { ascending: false }),
      supabase.from('enrollments').select('*'),
      supabase.from('courses').select('*'),
    ])
    setProfiles(p || [])
    setClasses(c || [])
    setEnrollments(e || [])
    setCourses(co || [])
    setLoading(false)
  }

  function switchTab(t) { setTab(t); setSearch(''); setExpanded(null) }

  const students = profiles.filter(p => p.role === 'student')
  const teachers = profiles.filter(p => p.role === 'teacher')

  const studentById = id => profiles.find(p => p.id === id)
  const courseById  = id => courses.find(c => c.id === id)

  const classRoster = classId =>
    enrollments.filter(e => e.class_id === classId).map(e => ({ ...e, student: studentById(e.student_id) })).filter(x => x.student)

  const studentEnrolments = studentId => enrollments.filter(e => e.student_id === studentId)

  const teacherClasses = teacherId => classes.filter(c => c.teacher_id === teacherId)

  const q = search.trim().toLowerCase()
  const filteredClasses = classes.filter(c => !q || [c.title, c.batch, c.teacher_name].some(v => v?.toLowerCase().includes(q)))
  const filteredStudents = students.filter(s => !q || [s.full_name, s.email, s.student_id, s.phone].some(v => v?.toString().toLowerCase().includes(q)))
  const filteredTeachers = teachers.filter(t => !q || [t.full_name, t.email].some(v => v?.toLowerCase().includes(q)))

  return (
    <div id="uniedd-directory" style={{ marginTop:'14px' }}>
      <div style={{ background:'rgba(var(--fg-rgb),0.04)', border:'0.5px solid rgba(var(--fg-rgb),0.07)', borderRadius:'14px', padding:'1rem 1.1rem' }}>

        {/* Tabs */}
        <div style={{ display:'flex', gap:'6px', marginBottom:'12px' }}>
          {TABS.map(t => (
            <button key={t.id} onClick={() => switchTab(t.id)} style={{
              display:'flex', alignItems:'center', gap:'6px', fontSize:'12px', fontWeight:700, padding:'7px 14px', borderRadius:'20px', cursor:'pointer', border:'none',
              background: tab === t.id ? '#1e90ff' : 'rgba(var(--fg-rgb),0.07)',
              color: tab === t.id ? '#fff' : 'rgba(var(--fg-rgb),var(--a45))',
            }}>
              <span>{t.icon}</span>{t.label}
            </button>
          ))}
        </div>

        {/* Search */}
        <input
          style={{ ...inp, width:'100%', boxSizing:'border-box', marginBottom:'12px' }}
          placeholder={tab === 'classes' ? 'Search by class title, batch or teacher...' : tab === 'students' ? 'Search by name, email, student ID or phone...' : 'Search by name or email...'}
          value={search}
          onChange={e => setSearch(e.target.value)}
          onFocus={e => e.target.style.borderColor = '#1e90ff'}
          onBlur={e => e.target.style.borderColor = 'rgba(var(--fg-rgb),0.1)'}
        />

        {loading ? (
          <div style={{ textAlign:'center', padding:'2rem', color:'rgba(var(--fg-rgb),var(--a20))', fontSize:'13px' }}>Loading...</div>
        ) : tab === 'classes' ? (
          filteredClasses.length === 0 ? (
            <div style={{ textAlign:'center', padding:'2rem', color:'rgba(var(--fg-rgb),var(--a20))', fontSize:'13px' }}>No classes found.</div>
          ) : (
            <div style={{ display:'grid', gap:'6px' }}>
              {filteredClasses.map(c => {
                const roster = classRoster(c.id)
                const isOpen = expanded === 'c-' + c.id
                return (
                  <div key={c.id} style={{ background:'rgba(var(--fg-rgb),0.03)', border:'0.5px solid rgba(var(--fg-rgb),0.05)', borderRadius:'10px', overflow:'hidden' }}>
                    <div onClick={() => setExpanded(isOpen ? null : 'c-' + c.id)} style={{ display:'flex', alignItems:'center', gap:'10px', padding:'10px 12px', flexWrap:'wrap', cursor:'pointer' }}>
                      <div style={{ flex:1, minWidth:'160px' }}>
                        <div style={{ fontSize:'13px', color:'rgba(var(--fg-rgb),var(--a85))', fontWeight:600 }}>
                          {c.title || 'Untitled Class'} {c.is_cancelled && <span style={{ fontSize:'10px', fontWeight:700, color:'#f87171', marginLeft:'6px' }}>CANCELLED</span>}
                        </div>
                        <div style={{ fontSize:'11px', color:'rgba(var(--fg-rgb),var(--a30))', marginTop:'1px' }}>
                          {fmtDate(c.class_date)} {c.start_time && '· ' + fmtTime(c.start_time)} {c.batch && '· ' + c.batch}
                        </div>
                      </div>
                      <div style={{ fontSize:'12px', color:'rgba(var(--fg-rgb),var(--a50))', flexShrink:0 }}>
                        👨‍🏫 {c.teacher_name || 'Unassigned'}
                      </div>
                      <div style={{ fontSize:'10px', fontWeight:700, padding:'3px 10px', borderRadius:'20px', background:'rgba(30,144,255,0.15)', color:'#5aabff', flexShrink:0 }}>
                        {roster.length} student{roster.length !== 1 ? 's' : ''}
                      </div>
                      <div style={{ fontSize:'11px', color:'rgba(var(--fg-rgb),var(--a25))', flexShrink:0 }}>{isOpen ? '▲' : '▼'}</div>
                    </div>
                    {isOpen && (
                      <div style={{ padding:'0 12px 12px', borderTop:'0.5px solid rgba(var(--fg-rgb),0.05)' }}>
                        {c.meet_link && (
                          <div style={{ margin:'10px 0' }}>
                            <a href={c.meet_link} target="_blank" rel="noreferrer" style={{ fontSize:'11px', fontWeight:700, padding:'4px 12px', borderRadius:'8px', background:'rgba(30,144,255,0.15)', color:'#5aabff', border:'0.5px solid rgba(30,144,255,0.25)' }}>Join Class</a>
                          </div>
                        )}
                        {roster.length === 0 ? (
                          <div style={{ fontSize:'12px', color:'rgba(var(--fg-rgb),var(--a25))', padding:'8px 0' }}>No students enrolled in this class yet.</div>
                        ) : (
                          <div style={{ display:'grid', gap:'4px', marginTop:'8px' }}>
                            {roster.map(r => {
                              const course = courseById(r.course_id)
                              return (
                                <div key={r.id} style={{ display:'flex', alignItems:'center', gap:'10px', padding:'6px 10px', background:'rgba(var(--fg-rgb),0.03)', borderRadius:'8px' }}>
                                  <div style={{ width:'26px', height:'26px', borderRadius:'50%', background:'rgba(16,185,129,0.2)', color:'#34d399', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'10px', fontWeight:800, flexShrink:0 }}>
                                    {initials(r.student.full_name)}
                                  </div>
                                  <div style={{ flex:1, minWidth:0 }}>
                                    <div style={{ fontSize:'12px', color:'rgba(var(--fg-rgb),var(--a75))', fontWeight:500 }}>{r.student.full_name}</div>
                                    <EmailChip email={r.student.email} />
                                  </div>
                                  {r.student.phone && <div style={{ fontSize:'11px', color:'rgba(var(--fg-rgb),var(--a30))' }}>{r.student.phone}</div>}
                                  {course && <div style={{ fontSize:'10px', color:'#a78bfa' }}>{course.title}</div>}
                                </div>
                              )
                            })}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                )
              })}
            </div>
          )
        ) : tab === 'students' ? (
          filteredStudents.length === 0 ? (
            <div style={{ textAlign:'center', padding:'2rem', color:'rgba(var(--fg-rgb),var(--a20))', fontSize:'13px' }}>No students found.</div>
          ) : (
            <div style={{ display:'grid', gap:'6px' }}>
              {filteredStudents.map(s => {
                const enrolments = studentEnrolments(s.id)
                const isOpen = expanded === 's-' + s.id
                return (
                  <div key={s.id} style={{ background:'rgba(var(--fg-rgb),0.03)', border:'0.5px solid rgba(var(--fg-rgb),0.05)', borderRadius:'10px', overflow:'hidden' }}>
                    <div onClick={() => setExpanded(isOpen ? null : 's-' + s.id)} style={{ display:'flex', alignItems:'center', gap:'10px', padding:'10px 12px', flexWrap:'wrap', cursor:'pointer' }}>
                      <div style={{ width:'32px', height:'32px', borderRadius:'50%', background:'rgba(16,185,129,0.15)', color:'#10b981', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'12px', fontWeight:800, flexShrink:0 }}>
                        {initials(s.full_name)}
                      </div>
                      <div style={{ flex:1, minWidth:'160px' }}>
                        <div style={{ fontSize:'13px', color:'rgba(var(--fg-rgb),var(--a85))', fontWeight:600 }}>{s.full_name || '—'}</div>
                        <EmailChip email={s.email} />
                      </div>
                      {s.phone && <div style={{ fontSize:'11px', color:'rgba(var(--fg-rgb),var(--a30))', flexShrink:0 }}>{s.phone}</div>}
                      {s.student_id && <div style={{ fontSize:'10px', fontWeight:700, padding:'3px 10px', borderRadius:'20px', background:'rgba(16,185,129,0.15)', color:'#10b981', flexShrink:0 }}>{s.student_id}</div>}
                      <div style={{ fontSize:'11px', color:'rgba(var(--fg-rgb),var(--a25))', flexShrink:0 }}>{isOpen ? '▲' : '▼'}</div>
                    </div>
                    {isOpen && (
                      <div style={{ padding:'0 12px 12px', borderTop:'0.5px solid rgba(var(--fg-rgb),0.05)' }}>
                        {s.timezone && <div style={{ fontSize:'11px', color:'rgba(var(--fg-rgb),var(--a30))', margin:'8px 0 0' }}>🌍 Timezone: {s.timezone}</div>}
                        <div style={{ fontSize:'11px', fontWeight:700, color:'rgba(var(--fg-rgb),var(--a35))', letterSpacing:'0.06em', textTransform:'uppercase', margin:'10px 0 6px' }}>Enrolments</div>
                        {enrolments.length === 0 ? (
                          <div style={{ fontSize:'12px', color:'rgba(var(--fg-rgb),var(--a25))' }}>Not enrolled in anything yet.</div>
                        ) : (
                          <div style={{ display:'grid', gap:'4px' }}>
                            {enrolments.map(e => {
                              const course = courseById(e.course_id)
                              const cls = classes.find(c => c.id === e.class_id)
                              return (
                                <div key={e.id} style={{ display:'flex', alignItems:'center', gap:'8px', padding:'6px 10px', background:'rgba(var(--fg-rgb),0.03)', borderRadius:'8px' }}>
                                  <span style={{ fontSize:'12px' }}>🎓</span>
                                  <div style={{ flex:1, minWidth:0, fontSize:'12px', color:'rgba(var(--fg-rgb),var(--a70))' }}>
                                    {course?.title || 'Course pending'}
                                    {cls && <span style={{ color:'rgba(var(--fg-rgb),var(--a35))' }}> · {cls.title} ({fmtDate(cls.class_date)}, {cls.teacher_name || 'Unassigned'})</span>}
                                  </div>
                                </div>
                              )
                            })}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                )
              })}
            </div>
          )
        ) : (
          filteredTeachers.length === 0 ? (
            <div style={{ textAlign:'center', padding:'2rem', color:'rgba(var(--fg-rgb),var(--a20))', fontSize:'13px' }}>No teachers found.</div>
          ) : (
            <div style={{ display:'grid', gap:'6px' }}>
              {filteredTeachers.map(t => {
                const taught = teacherClasses(t.id)
                const isOpen = expanded === 't-' + t.id
                return (
                  <div key={t.id} style={{ background:'rgba(var(--fg-rgb),0.03)', border:'0.5px solid rgba(var(--fg-rgb),0.05)', borderRadius:'10px', overflow:'hidden' }}>
                    <div onClick={() => setExpanded(isOpen ? null : 't-' + t.id)} style={{ display:'flex', alignItems:'center', gap:'10px', padding:'10px 12px', flexWrap:'wrap', cursor:'pointer' }}>
                      <div style={{ width:'32px', height:'32px', borderRadius:'50%', background:'rgba(30,144,255,0.15)', color:'#1e90ff', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'12px', fontWeight:800, flexShrink:0 }}>
                        {initials(t.full_name)}
                      </div>
                      <div style={{ flex:1, minWidth:'160px' }}>
                        <div style={{ fontSize:'13px', color:'rgba(var(--fg-rgb),var(--a85))', fontWeight:600 }}>{t.full_name || '—'}</div>
                        <EmailChip email={t.email} />
                      </div>
                      <div style={{ fontSize:'10px', fontWeight:700, padding:'3px 10px', borderRadius:'20px', background:'rgba(30,144,255,0.15)', color:'#5aabff', flexShrink:0 }}>
                        {taught.length} class{taught.length !== 1 ? 'es' : ''}
                      </div>
                      <div style={{ fontSize:'11px', color:'rgba(var(--fg-rgb),var(--a25))', flexShrink:0 }}>{isOpen ? '▲' : '▼'}</div>
                    </div>
                    {isOpen && (
                      <div style={{ padding:'0 12px 12px', borderTop:'0.5px solid rgba(var(--fg-rgb),0.05)' }}>
                        {taught.length === 0 ? (
                          <div style={{ fontSize:'12px', color:'rgba(var(--fg-rgb),var(--a25))', padding:'8px 0' }}>No classes assigned yet.</div>
                        ) : (
                          <div style={{ display:'grid', gap:'4px', marginTop:'8px' }}>
                            {taught.map(c => (
                              <div key={c.id} style={{ display:'flex', alignItems:'center', gap:'8px', padding:'6px 10px', background:'rgba(var(--fg-rgb),0.03)', borderRadius:'8px' }}>
                                <div style={{ flex:1, minWidth:0, fontSize:'12px', color:'rgba(var(--fg-rgb),var(--a70))' }}>
                                  {c.title} {c.batch && <span style={{ color:'rgba(var(--fg-rgb),var(--a35))' }}>· {c.batch}</span>}
                                </div>
                                <div style={{ fontSize:'11px', color:'rgba(var(--fg-rgb),var(--a30))' }}>{fmtDate(c.class_date)} {c.start_time && fmtTime(c.start_time)}</div>
                                {c.is_cancelled && <span style={{ fontSize:'10px', fontWeight:700, color:'#f87171' }}>CANCELLED</span>}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                )
              })}
            </div>
          )
        )}
      </div>
    </div>
  )
}
